<div
    class="main_content aumico-grid"
    [style.gridTemplateRows]="
        !hideFooter ? '[header] auto [content] 1fr [footer] 64px' : '[header] auto [content] 1fr [footer] 0px'
    "
>
    <div class="aumico-nested-grid aumico-grid-row-header">
        <div style="grid-column: 1 / 17">
            <ng-content select="[header]"></ng-content>
        </div>
    </div>
    <div id="mainscrollcontent" class="aumico-content-grid aumico-grid-row-content">
        <div style="grid-column: 1 / 17">
            <ng-content select="[content]"></ng-content>
        </div>
    </div>
    <div class="aumico-nested-grid aumico-grid-row-footer" [ngClass]="{ 'hidden-footer': hideFooter }">
        <div style="grid-column: 1 / 17">
            <ng-content select="[footer]"></ng-content>
            <ng-container *ngTemplateOutlet="footerOutlet"></ng-container>
        </div>
    </div>
</div>
